'use client';
import {Carousel, Toast} from "@/app/_components";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {PwaGuideDialogFC} from "@/app/(shop)/UI/PwaGuideDialog/PwaGuideDialogFC";
import {FirstChargeGiftPackDialogFC} from "@/app/(shop)/UI/FirstChargeGiftPackDialog/FirstChargeGiftPackDialog";
import {SpecialGiftPackDialogFC} from "@/app/(shop)/UI/SpecialGiftPackDialog/SpecialGiftPackDialog";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {selectShopItems} from "@/app/(pages)/shopItemsSlice";
import React, {MouseEventHandler, useEffect, useRef, useState} from "react";
import {getPaymentItemsAsync} from "@/app/(pages)/paymentItemsAPI";
import KitPwa from "@/Master/PWA/KitPwa";
import {selectUserInfo, SET_ADD_DESKTOP_REWARDS, SET_ADD_DESKTOP_REWARDS_GC} from "@/app/userSlice";
import "./Banner.css";
import Image from "next/image";

const images = [
    {
        id: 1,
        url: '/img/home/banner.webp'
    },
    {
        id: 2,
        url: '/img/home/banner3.webp'
    },
    {
        id: 3,
        url: '/img/home/banner2.webp'
    },
];

enum BannerType {
    AddDesktop = 1, //添加桌面
    SpecialGift, //特价礼包
    FirstRechargeGift, //首充礼包
}

let isSwiping = false;
export default function banner() {
    const userInfo  = useAppSelector(selectUserInfo);
    const dispatch = useAppDispatch();
    const shopItem = useAppSelector(selectShopItems);
    const [isClickReward, setClickReward] = useState(false);
    const [scCount, setScCount] = useState(-1);

    // let isSwiping = useRef<any>();

    const settings = {
        arrows: false,
        customPaging: (i: number) => (
            <div className="indicator">
                <div
                    key={images[i].id}
                    className="indicator_item"
                >
                </div>
            </div>
        ),
        autoplay: true,
        autoplaySpeed: 5000,
    }

    useEffect(() => {
        // setEverInstall(DataMgr.getStorage(fwkConst.EVER_INSTALLED))
        if (KitPwa.isPlayPwa){
            setClickReward(false)
        }else{
            setClickReward(true)
        }
        if (shopItem.shopItemsSpecialData.length <= 0) {
            dispatch(getPaymentItemsAsync({userId: userInfo.userId, itemsType: 2}))
        }
        if (shopItem.shopItemsStarterData.length <= 0) {
            dispatch(getPaymentItemsAsync({userId: userInfo.userId, itemsType: 3}))
        }
        // RewardApply.Instance.RequestRewardConfig(RewardSource.AddDesktop, (data) => {
        //     if(data.code === 200){
        //         if(Util.isLog){
        //             console.log('RequestRewardConfig',data.data)
        //             console.log('rewards===dispatch(SET_ADD_DESKTOP_REWARDS(data.data.scBonus))')
        //         }
        //         setScCount(data.data.scBonus)
        //         dispatch(SET_ADD_DESKTOP_REWARDS(data.data.scBonus))
        //         dispatch(SET_ADD_DESKTOP_REWARDS_GC(data.data.gcBonus))
        //     }
        // }).then( r => {
        //
        // })
        // 组件卸载时移除事件监听
    }, []);

    const [ClientXonMouseDown, setClientXonMouseDown] = useState();
    const [ClientYonMouseDown, setClientYonMouseDown] = useState();
    const handleOnMouseDown = (e: any) => {
        e.preventDefault();
        setClientXonMouseDown(e.clientX);
        setClientYonMouseDown(e.clientY);
    };

    function updateSwipeState (state: any) {
        isSwiping = state;
    }

    const onBannerClick = (e: React.MouseEvent<HTMLDivElement>, id: BannerType) => {
        e.stopPropagation();
        if (ClientXonMouseDown !== e.clientX || ClientYonMouseDown !== e.clientY) {
            return;
        } else {
            if (id === BannerType.AddDesktop) {
                    SDialogManagerFC.openDialog(PwaGuideDialogFC,{
                        fcKey: SDialogManagerFC.getFCKey(PwaGuideDialogFC),
                    });

            } else if (id === BannerType.FirstRechargeGift) {
                if (userInfo.starterPackFlag) {
                    Toast.show({
                        duration: 5000,
                        content: <div style={{padding: '.2rem'}}>
                            <div style={{marginBottom: '.2rem'}}>1: purchase is limited to once</div>
                            <div>2: Orders purchased repeatedly due to network issues </div>
                            <div>will be converted</div>
                            <div style={{marginTop: '.2rem'}}>1SC = 1USD</div>
                        </div>
                    });
                    return;
                }
                SDialogManagerFC.openDialog(FirstChargeGiftPackDialogFC, {
                    fcKey: SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC),
                    userId: userInfo.userId,
                    shopItemsStarterData: shopItem.shopItemsStarterData,
                    dispatcher: dispatch,
                });
            } else if (id === BannerType.SpecialGift) {
                SDialogManagerFC.openDialog(SpecialGiftPackDialogFC, {
                    fcKey: SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC),
                    userId: userInfo.userId,
                    shopItemsSpecialData: shopItem.shopItemsSpecialData,
                    dispatcher: dispatch,
                });
            }
        }
    }

    return (
        <div className="banner">
            <div className="banner_main">
                <Carousel settings={{...settings}}>
                    {images.map(image =>
                        <div
                            className="image_div"
                            key={image.id}
                            onMouseDown={(e) => handleOnMouseDown(e)}
                            onClick={(event) => onBannerClick(event, image.id)}
                        >
                            {/*<img src={image.url} alt="" />*/}
                            <Image
                                src={image.url}
                                alt={image.url}
                                // width={1080}
                                // height={800}
                                fill // 使用 fill 属性让图片填满容器
                                style={{objectFit: 'fill',height: '100%'}}
                                // sizes="(max-width: 768px) 90vw, 60vw"
                                loading="lazy"
                                placeholder={'blur'}
                                blurDataURL="/loading.webp"
                            >
                            </Image>
                            {image.id === 1 && userInfo.addDesktopRewards > 0 && !userInfo.addDesktopOpen &&
                                <div className="banner_info">
                                    <img src="/img/ico_sc.png" alt=""/>
                                    <div>
                                        {userInfo.addDesktopRewards} SC FREE
                                    </div>
                                </div>}
                        </div>
                    )}
                </Carousel>
            </div>

        </div>
    )
}
